import { NgModule } from '@angular/core';
import { QuillModule } from 'ngx-quill';
import { RichTextEditorComponent } from './rich-text-editor.component';
import { IconModule } from '../icon/icon.module';
import { RichTextEditorToolbarComponent } from './rich-text-editor-toolbar/rich-text-editor-toolbar.component';
import { NgClass } from '@angular/common';

@NgModule({
	declarations: [RichTextEditorComponent, RichTextEditorToolbarComponent],
	imports: [QuillModule.forRoot(), IconModule, NgClass],
	exports: [RichTextEditorComponent],
})
export class RichTextEditorModule {}
